import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOffer } from 'logic/store/offer/offer.selectors';

export const useCurrentOffer = () => {
  const { id } = useParams<{ id: string }>();

  return {
    offer: useSelector(getOffer(id)),
    offerId: id,
  };
};
